var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"mMenuCol"},[_c('div',{staticClass:"menuDiscount"},[_c('div',{staticClass:"discountImg"},[_c('img',{attrs:{"src":_vm.image_url,"alt":""}})]),_c('span',[_vm._v(_vm._s(_vm.small_text))]),_c('div',{staticClass:"h3"},[_vm._v(_vm._s(_vm.big_text))]),_c('a',{attrs:{"href":_vm.action_url}},[_vm._v(_vm._s(_vm.action_text))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fd50fbc","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tryNowMenu.vue
// module id = null
// module chunks = 